<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap justify-center align-center>
      <v-flex class="md6 text-md-left mt-1">
        <filters-bar
          :date="false"
          :filters="filters"
          :filtersButton="false"
          :has-date-type="false"
          :has-company-load="true"
          box-size="md6"
          title-box-size="md6"
          company-load-box-size="md8"
          title="Gestión de la cartera"
          title-class="headline font-weight-thin" 
          @search="search">
          <template slot="content">
            <v-flex md4>
              <v-btn
                block
                class="h-100 ma-0 w-100 btn-download"
                @click="showModal = true">
                  <v-icon small>fas fa-download</v-icon>
              </v-btn>
            </v-flex>
          </template>
        </filters-bar>
      </v-flex>
      <v-flex md6 class="custom-filters">
        <filters-bar
          title="Carga diaria"
          title-class="headline font-weight-thin" 
          title-box-size="md3"
          box-size="md9"
          date-box-size="md5"
          btn-filter-size="md3"
          :filters="filters"
          :has-date-type="false"
          @search="search">
          <template slot="content">
            <v-flex md2>
              <v-btn
                block
                class="h-100 ma-0 w-100 btn-download"
                @click="generateReport('customerReport')">
                  <v-icon small>fas fa-download</v-icon>
              </v-btn>
            </v-flex>
          </template>
        </filters-bar>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex md6 pa-0>
        <schedule
          :filters="filters"
          :date="dateSchedule"
          :step="internalStep"
          @load-funnel-step="loadFunnelData"
          @update-step="internalStep = $event"
          :isSearching="isSearchingSchedule"
          :data="dataSchedule" />
      </v-flex>
      <v-flex md6>
        <daily-load :date="dateDailyLoad" :step="internalStep" @update-step="internalStep = $event" :isSearching="isSearchingDailyLoad" :filters="filters"
          :data="dataDaily"
          :dataPie="dataPie"/>
      </v-flex>
    </v-layout>
    <v-dialog :value="show" max-width="500" @input="close">
      <v-card>
        <v-card-title class="headline">Etapa: {{ selectedStep }}</v-card-title>
        <v-card-text>
          <template v-if="customers.length > 0">
            <vue-perfect-scrollbar class="customer-status--scrollbar">
              <v-list-tile class="b-borders ml-4" v-for="(customer, i) in customers" :key="i">
                <v-layout row wrap class="f0-9em">
                  <v-flex md6>
                    <v-icon small class="pr-3">fas fa-{{ getCustomerField('id', customer.customer_status_id, 'icon') }}</v-icon>
                    {{ getCustomerField('id', customer.customer_status_id, 'status') }}
                  </v-flex>
                  <v-flex md6 class="pl-4">
                    {{ customer.quantity }}
                  </v-flex>
                </v-layout>
              </v-list-tile>
              <v-list-tile class="ml-4">
                <v-layout row wrap class="f0-9em">
                  <v-flex md6>
                    <strong>Total</strong>
                  </v-flex>
                  <v-flex md6 class="pl-4">
                    {{new Intl.NumberFormat('es-VE').format(customerTotal)}}
                  </v-flex>
                </v-layout>
              </v-list-tile>
            </vue-perfect-scrollbar>
          </template>
          <template v-else>
            <v-list-tile>
              <v-layout row wrap>
                <v-flex md12 class="text-xs-center">
                  No se encontraron resultados
                </v-flex>
              </v-layout>
            </v-list-tile>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <download-modal :show="showModal" 
      @change="showModal = $event"
      :items="downloadOptions"
      label="Tipo de clientes"
      @download="generateReport('customer_ns_stage', $event)"></download-modal>
  </v-container>
</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import FiltersBar from '@/components/global/FiltersBar';
import statusMixin from '@/mixins/status';
import Schedule from './Schedule/Index';
import DailyLoad from './DailyLoad/Index';
import DownloadModal from '../DownloadModal';

export default {
  mixins: [
    statusMixin,
  ],
  props: {
    dateSchedule: {
      type: [String, undefined],
      default: 'Buscando...',
    },
    dateDailyLoad: {
      type: [String, undefined],
      default: 'Buscando...',
    },
    step: {
      type: Number,
      default: 0,
    },
  },
  components: {
    DownloadModal,
    FiltersBar,
    DailyLoad,
    Schedule,
  },
  data() {
    return {
      show: false,
      selectedStep: '',
      customers: [],
      dataSchedule: [
        {
          name: 'Clientes',
          value: 0,
          percent: 0,
        },
        {
          name: 'Gestionado',
          value: 0,
          percent: 0,
        },
        {
          name: 'Contactado',
          value: 0,
          percent: 0,
        },
        {
          name: 'Contacto útil',
          value: 0,
          percent: 0,
        },
        {
          name: 'Compromiso',
          value: 0,
          percent: 0,
        },
      ],
      dataDaily: [
        {
          icon: 'fas fa-file-alt',
          title: 'Archivo de Lectura',
          total: 0,
        },
        {
          icon: 'fas fa-file-signature',
          title: 'Antes de filtros',
          total: 0,
        },
        {
          icon: 'fas fa-filter',
          title: 'Despues de filtros',
          total: 0,
        },
        {
          icon: 'fas fa-database',
          title: 'Cargados',
          total: 0,
        },
      ],
      dataPie: [
        {
          name: 'Gestionado',
          value: 0,
        },
        {
          name: 'Sin gestionar',
          value: 0,
        },
      ],
      filters: {
        date: moment().format('YYYY-MM-DD'),
        dateType: 'date',
        company_load: 0,
        total_load: 0,
      },
      downloadOptions: [
        {
          text: 'Todos',
          value: 0,
        },
        {
          text: 'Gestionados',
          value: 2,
        },
        {
          text: 'No gestionados',
          value: 1,
        },
        {
          text: 'Contactado',
          value: 3,
        },
        {
          text: 'Contacto útil',
          value: 4,
        },
        {
          text: 'Compromiso',
          value: 5,
        },
      ],
      showModal: false,
      isSearchingSchedule: true,
      isSearchingDailyLoad: true,
      token1: this.axios.CancelToken.source(),
      token2: this.axios.CancelToken.source(),
      internalStep: 1,
      oldDate: moment().format('YYYY-MM-DD'),
    };
  },
  computed: {
    ...mapGetters([
      'companyLoad',
    ]),
    customerTotal() {
      let total = 0;
      if (this.customers.length > 0) {
        this.customers.forEach((customer) => {
          total += parseInt(customer.quantity, 10);
        });
      }
      return total;
    },
  },
  methods: {
    cancelRequest(id) {
      this[`token${id}`].cancel('');
      this[`token${id}`] = this.axios.CancelToken.source();
    },
    searchSchedule() {
      const obj = { ...this.filters };
      if (obj.date !== this.oldDate) {
        obj.company_load = 0;
        if (obj.date === moment().format('YYYY-MM-DD')) {
          obj.total_load = 0;
        }
      }
      this.cancelRequest(1);
      this.isSearchingSchedule = true;
      this.axios.get('schedules/report', {
        cancelToken: this.token1.token,
        params: {
          ...obj,
        },
      }).then((res) => {
        this.oldDate = this.filters.date;
        this.filters.company_load = res.data.companyLoadId;
        this.dataSchedule[0].value = res.data.allCustomers;
        this.dataSchedule[1].value = res.data.totalNs.total;
        this.dataSchedule[2].value = res.data.totalNs.contacted;
        this.dataSchedule[3].value = res.data.totalNs.reached;
        this.dataSchedule[4].value = res.data.totalNs.promise;
        const data = this.dataSchedule;
        for (let i = 0; i < data.length; i += 1) {
          data[i].percent = (data[i].value * 100) / data[0].value;
        }
        this.isSearchingSchedule = false;
      }).catch(() => {
      }).then(() => {
        if (
          this.dataSchedule[0].value < 1
          || (
            this.dataSchedule[0].value > 0
            && this.dataSchedule[1].value < 1
          )
        ) {
          this.internalStep = 2;
        }
      });
    },
    searchDailyLoad() {
      const obj = { ...this.filters };
      if (obj.date !== this.oldDate) {
        obj.company_load = 0;
      }
      this.cancelRequest(2);
      this.isSearchingDailyLoad = true;
      this.dataDaily[0].total = 0;
      this.dataDaily[1].total = 0;
      this.dataDaily[2].total = 0;
      this.dataDaily[3].total = 0;
      this.dataPie[0].value = 0;
      this.dataPie[1].value = 0;

      this.axios.get('daily_load/report', {
        cancelToken: this.token2.token,
        params: {
          ...obj,
        },
      }).then((res) => {
        const data = res.data;
        const stages = data.stages;
        this.dataDaily[0].total = Number(res.data.all);
        for (let i = 1; i < this.dataDaily.length; i += 1) {
          // eslint-disable-next-line
          this.dataDaily[i].total = (stages.find(x => x.type_id === (i + 1)) || {}).total || 0;
        }
        this.dataPie[0].value = Number(data.customerNs);
        if (this.dataDaily[3].total > 0) {
          // eslint-disable-next-line
          this.dataPie[1].value = this.dataDaily[3].total - this.dataPie[0].value;
        } else {
          this.dataPie[1].value = 0;
        }
        this.isSearchingDailyLoad = false;
      }).then(() => {
        if (this.dataPie[0].value < 1) {
          this.internalStep = 3;
        }
      });
    },
    generateReport(functionName, customerType = null) {
      const obj = { ...this.filters };
      if (functionName === 'customerReport') {
        obj.filename = 'Reporte carga diaria';
        obj.last_sync_date = obj.date;
        delete obj.total_load;
      } else {
        obj.dateType = 'month';
        obj.ns_stage = customerType;
      }
      obj.last_company_load = obj.company_load;
      delete obj.company_load;
      // eslint-disable-next-line
      obj.last_company_load = obj.company_load || (this.companyLoad.find(x => x.priority === 1) || {}).id || 0;
      this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
      this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
        route: 'reports',
        params: {
          filters: {
            ...obj,
          },
          functionName,
        },
      });
    },
    search(filters) {
      this.filters = {
        ...this.filters,
        ...filters,
      };
      this.internalStep = 1;
      this.searchSchedule();
      this.searchDailyLoad();
    },
    loadFunnelData($event) {
      const obj = { ...this.filters };
      if (obj.date !== this.oldDate) {
        obj.company_load = 0;
        if (obj.date === moment().format('YYYY-MM-DD')) {
          obj.total_load = 0;
        }
      }
      this.axios($event.url, {
        params: {
          ...obj,
        },
      }).then(({ data }) => {
        this.show = true;
        this.selectedStep = $event.step;
        this.customers = data.result;
      }).catch(() => {});
    },
    close($event) {
      if (!$event) {
        this.show = false;
      }
    },
  },
  watch: {
    step(val) {
      if (val === 1) {
        this.searchSchedule();
        this.searchDailyLoad();
      }
    },
    internalStep(value) {
      if (value === 3) {
        this.$emit('update-step', 3);
      }
    },
    filters: {
      deep: true,
      handler(val) {
        if (!val.company_load) {
          this.filters.company_load = (this.companyLoad.find(x => x.priority === 1) || {}).id || 0;
        }
      },
    },
    'filters.total_load': {
      handler() {
        this.searchSchedule();
      },
    },
    companyLoad(val) {
      if (!this.filters.company_load && val.length > 0) {
        let check = this.companyLoad.find(x => x.check > 0);
        if (!check) {
          check = this.companyLoad.find(x => x.priority === 1);
        }
        this.filters.company_load = (check || {}).id || 0;
      }
    },
  },
};
</script>
<style scoped>
.btn-download {
  min-width: auto!important;
}
.custom-layout {
  padding-top: 0;
}
.custom-layout > .flex{
  padding-top: 0px !important;
  padding-left: 15px !important;
}
.custom-filters >>> .container.grid-list-md {
  padding: 0;
}
.custom-filters >>> .input-group__selections__comma {
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>




// WEBPACK FOOTER //
// src/components/panelV2/ScheduleDaily/Index.vue